import { TFunction } from 'i18next'

import { BaseMapTask, newBaseAosMapTask } from '../../../map/types/MapTask'
import { TaskType } from '../TaskType'
import { AnimalsTask } from './AnimalsTask'
import { DeIcingTask } from './DeIcingTask'
import { InspectionTask } from './InspectionTask'
import { MaintenanceTask } from './MaintenanceTask'
import { RefuellingTask } from './RefuellingTask'
import { RescueServiceTask } from './RescueServiceTask'
import { SimpleTask } from './SimpleTask'
import { AnyTaskTemplate } from './TaskTemplate'
import { TerminalTask } from './TerminalTask'

export type Task =
    | AnimalsTask
    | MaintenanceTask
    | DeIcingTask
    | RescueServiceTask
    | InspectionTask
    | SimpleTask
    | RefuellingTask
    | TerminalTask

export const mapTaskForTask = (task: Task): BaseMapTask | null => {
    if (task.location) {
        return newBaseAosMapTask(task.location, task)
    }
    return null
}

export const translateTaskType = (t: TFunction) => (type: TaskType) =>
    t(`task-type.${type}`, { ns: 'tasks' })

export type TaskOrTemplate = Task | AnyTaskTemplate
